module Meevo.Plugins.MerchantAccounts {
    export class DeviceLogoUploadModalController
    {
        static $inject = ["$scope", "$q", "meevo.components.common.DataService", "Upload", "$mdDialog", "device"];
        uploading = false;
        config = undefined;

        constructor(
            private $scope: any,
            private $q: angular.IQService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private Upload,
            private $mdDialog: ng.material.IDialogService,
            private device
        ) {
            this.$scope.config = {
                pattern: ".png",
                size: {
                    max: "512KB"
                }
            };
        }

        uploadFile(): void {
            this.uploading = true;
            this.Upload.dataUrl(this.$scope.file, true).then(data => {
                let device = _.clone(this.device);
                device.logo = data.split(",")[1];
                this.dataService.customMethodData(`api/merchantTerminal/${this.device.id}/logo`, "PUT", device).then(() => {
                    this.device.logo = data;
                    this.close();
                }).finally(() => {
                    this.uploading = false;
                });
            });
        }

        close(): void {
            this.$scope.file = undefined
            this.$mdDialog.hide(false);
        }
    }
    angular.module("meevo.plugins.merchantAccounts")
        .controller("meevo.plugins.merchantAccounts.DeviceLogoUploadModalController", DeviceLogoUploadModalController);
}